/**
 *
 *
 *
 *
 */

/*                                                               */

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
var _createImage = function (imgPlaceholder, imgAttributes, onloadCallback) {
    var img = document.createElement("img");

    img.onload = function () {
        if (onloadCallback) {
            onloadCallback.call(img);
        }
    };
    if (imgAttributes.title) {
        img.title = imgAttributes.title;
    }
    if (imgAttributes.errorHandler) {
        img.setAttribute("onerror", imgAttributes.errorHandler);
    }
    if (imgAttributes.srcset) {
        img.setAttribute("srcset", imgAttributes.srcset);
    }
    img.alt = imgAttributes.alt;
    img.src = encodeURI(imgAttributes.src);
    img.classList.add(imgAttributes.className);

    _replacePlaceholderWithImage(imgPlaceholder, img);
};

/**
 *
 *
 *
 *
 */
var _replacePlaceholderWithImage = function (imgPlaceholder, img) {
    var parentNode = imgPlaceholder.parentNode;
    if (parentNode) {
        parentNode.replaceChild(img, imgPlaceholder);
    }
};

/**
 *
 *
 *
 *
 *
 */
var _resolveImageAttributes = function (imgPlaceholder) {
    return {
        src: imgPlaceholder.getAttribute("data-src"),
        alt: imgPlaceholder.getAttribute("data-alt"),
        title: imgPlaceholder.getAttribute("data-title"),
        errorHandler: imgPlaceholder.getAttribute("data-error-handler"),
        srcset: imgPlaceholder.getAttribute("data-srcset"),
        className: imgPlaceholder.getAttribute("data-class")
    };
};

var _validateOptions = function (options) {
    return options || {};
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
var lazyLoad = function (imgPlaceholder, options) {
    var imgAttributes = _resolveImageAttributes(imgPlaceholder);
    options = _validateOptions(options);

    if (!!imgAttributes.src && (!!imgAttributes.alt || imgAttributes.alt === "")) {
        _createImage(imgPlaceholder, imgAttributes, options.onloadCallback);
    } else {
        if (options.onerrorCallback) {
            options.onerrorCallback.call(imgPlaceholder);
        }
    }
};

export default {
    lazyLoad: lazyLoad
}